export const privacyPolicyTypes = {
  WithCheckbox: 1,
  WithoutCheckbox: 2,
}
